// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"831cda0d","565":"cc2f50e1","805":"837f1cf7","887":"d071fe90","932":"20df4326","956":"8606b1b0"}[chunkId] + ".chunk.js";
};